let ratio = 1;

export default {
  mounted() { },
  data() {
    return {
      tweenSpeeds: {
        dur: {
          introAnim: 3 * ratio,
          cardShow: 0.5 * ratio,
          headerBarResize: 0.5 * ratio,
          itemFadeIn: 1 * ratio,
          staggerDiff: 0.2 * ratio,
          scrollerTweenSpeedForCard: 0.65 * ratio,
          sceneOffset: 0.4 * ratio,
          gameoverOffset: 2 * ratio,
          firstFloorRoofs: 4 * ratio,
          secondFloorRoofs: 4 * ratio,
          secondFloorWalls: 4 * ratio,
          upstairsRooms: 2 * ratio,
          firstFloorWalls: 4 * ratio,
          cameraFov: 3 * ratio,
          introCameraPosition: 3 * ratio,
          objectFadeIn: 0.5,
          objectFadeOut: 0.05,
          roomFadeIn: 0.2 * ratio,
          roomFadeOut: 0.4 * ratio,
          objectStaggerDiff: 0,
          fadeVeggies: 3 * ratio,
          cameraPos1: 3 * ratio,
          cameraPos2: 3 * ratio,
          cameraPos3: 3 * ratio,
          questionCardSwap: 0.5 * ratio,
          continueButtonDelay: 0.05 * ratio,
          roomButtonHide: 0.3 * ratio,
          roomButtonShow: 0.8 * ratio,
          roomButtonShowStaggerDiff: 1.2,
          testimonialsEnter: 0.5,
          finalScoreEnter: 1,
          showFinalScoreDelay: 3,
          howToOverlayFade: 0.5,
          loaderFadeIn: 1,
          loaderFadeOut: 1,
          // new tweens
          screenWipe: 2.0,
          commercialWalls: 4 * ratio
        },
        ease: {
          global: 'Power2.easeInOut',
          house: 'Power2.easeInOut'
        }
      }
    };
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/plugins/tweenSpeedsMixin.js